module.exports = __webpack_public_path__ + "assets/images/truck.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/truck.png
// module id = 260
// module chunks = 1